(function(){
  'use strict';
  var C = window.ETA || {};

  /*
   * Qui c'era "if (!C.variants) return".
   *
   * Serviva alla logica del prodotto, che senza varianti non ha niente da
   * calcolare. Ma questo file non fa solo la scheda prodotto: aggancia anche il
   * menu, il carrello e i popup delle policy, che stanno su ogni pagina. Sulla
   * homepage non c'è nessun prodotto, quindi lo script usciva alla seconda riga
   * e nessun pulsante rispondeva più — senza un errore in console, perché
   * uscire non è sbagliare.
   *
   * Ora la mancanza del prodotto spegne solo quello che riguarda il prodotto.
   */
  var HASPROD = !!(C.variants && C.variants.length);

  var NOPT = C.optionCount || 2;
  var BQ = 1, BD = 0;
  var L = C.labels || {};

  /* ---------------- utility ---------------- */

  function money(cents){
    var v = (cents/100).toFixed(2);
    return C.decimalComma !== false
      ? v.replace('.', ',') + ' ' + (C.currencySymbol || '€')
      : (C.currencySymbol || '€') + v;
  }

  function variantFor(opts){
    for (var i=0;i<C.variants.length;i++){
      var v = C.variants[i], ok = true;
      for (var j=0;j<NOPT;j++){ if (String(v.options[j]) !== String(opts[j])) { ok=false; break; } }
      if (ok) return v;
    }
    return null;
  }

  function firstAvail(){
    for (var i=0;i<C.variants.length;i++){ if (C.variants[i].available) return C.variants[i]; }
    return C.variants[0];
  }

  function unit(){ var v = firstAvail(); return v ? v.price : 0; }

  /*
   * Sconto a scaglioni. Somma i prezzi di riga in EURO e poi arrotonda: è la
   * stessa sequenza di operazioni del bridge di checkout. Sommare in centesimi
   * o moltiplicare darebbe un centesimo di scarto (39,90 x 3 in float fa
   * 119.69999999999999, non 119.70) e il totale mostrato non combacerebbe.
   */
  /*
   * Si somma in centesimi e si divide alla fine. Sommando in euro,
   * 39.90 tre volte fa 119.69999999999999 e lo sconto del 25% arrotonda a
   * 29.92 invece di 29.93: un centesimo di differenza fra quello che il
   * cliente legge qui e quello che gli addebita il checkout.
   */
  function bundleDisc(cents, d){
    if (!d) return 0;
    var sub = 0;
    for (var i=0;i<cents.length;i++) sub += cents[i];
    return Math.round(sub*d);
  }

  function bundleTot(u, q, d){
    var l = [];
    for (var i=0;i<q;i++) l.push(u);
    return u*q - bundleDisc(l, d);
  }

  /* ---------------- prezzi bundle ---------------- */

  /*
   * Riferimento per il prezzo barrato e il "Risparmi":
   *  - scaglione senza sconto (1 pezzo)  -> il compare-at price del prodotto
   *  - scaglione con sconto              -> il prezzo pieno per quella quantità
   * Se non c'è compare-at, sul primo scaglione non mostriamo nulla di barrato.
   */
  function bundlePrices(){
    var u = unit(), cmp = C.compareAt || 0;
    document.querySelectorAll('.eta-bun').forEach(function(b){
      var q = +b.dataset.q, d = +b.dataset.d;
      var tot = bundleTot(u, q, d);
      var ref = d > 0 ? u*q : (cmp > u ? cmp*q : 0);
      var save = ref > tot ? ref - tot : 0;

      var pv = b.querySelector('.bpv'), po = b.querySelector('.bpo'), sv = b.querySelector('.bsv');
      if (pv) pv.textContent = money(tot);
      if (po){
        po.textContent = money(ref);
        po.hidden = save <= 0;
      }
      if (sv){
        sv.textContent = (L.save || 'You save') + ' ' + money(save);
        sv.hidden = save <= 0;
      }
    });
  }

  function pickBun(el){
    document.querySelectorAll('.eta-bun').forEach(function(b){ b.classList.remove('on'); });
    el.classList.add('on');
    BQ = +el.dataset.q; BD = +el.dataset.d;
    bundlePrices();
  }

  /* ---------------- galleria ---------------- */

  var car = document.getElementById('eta-car');

  /*
   * Le foto oltre la prima entrano quando la pagina ha finito di caricare,
   * oppure appena il dito tocca il carosello — quello che viene prima. Così non
   * rubano banda alla foto che si sta guardando, che è quella che decide quanto
   * la pagina sembra veloce.
   */
  function caricaResto(){
    if (!car) return;
    var pigre = car.querySelectorAll('img[data-src]');
    for (var i=0;i<pigre.length;i++){
      var im = pigre[i];
      if (im.dataset.srcset) im.srcset = im.dataset.srcset;
      im.src = im.dataset.src;
      im.removeAttribute('data-src');
      im.removeAttribute('data-srcset');
    }
  }
  if (document.readyState === 'complete') setTimeout(caricaResto, 0);
  else window.addEventListener('load', caricaResto, { once: true });
  if (car) car.addEventListener('touchstart', caricaResto, { once: true, passive: true });

  if (car){
    car.scrollLeft = 0;
    requestAnimationFrame(function(){ car.scrollLeft = 0; });
    var st;
    car.addEventListener('scroll', function(){
      clearTimeout(st);
      st = setTimeout(function(){
        var i = Math.round(car.scrollLeft / car.clientWidth);
        document.querySelectorAll('.eta-thumb').forEach(function(x, j){ x.classList.toggle('on', j===i); });
      }, 50);
    }, { passive:true });
  }
  document.querySelectorAll('.eta-thumb').forEach(function(t){
    t.addEventListener('click', function(){
      if (car) car.scrollTo({ left: car.clientWidth * (+t.dataset.i), behavior:'smooth' });
    });
  });

  function scrollToColor(val){
    if (!car || !C.colorImage) return;
    var pos = C.colorImage[val];
    if (pos) car.scrollTo({ left: car.clientWidth*(pos-1), behavior:'smooth' });
  }

  /* ---------------- dropdown varianti ---------------- */

  function closeVMenus(){
    document.querySelectorAll('.eta-vsel.open').forEach(function(v){ v.classList.remove('open'); });
  }

  function vToggle(trig){
    var vs = trig.parentNode;
    var wasOpen = vs.classList.contains('open');
    closeVMenus();
    if (wasOpen) return;
    vs.classList.add('open');
    var m = vs.querySelector('.eta-vmenu');
    var r = trig.getBoundingClientRect();
    m.style.left = r.left + 'px';
    m.style.width = r.width + 'px';
    m.style.top = (r.bottom + 6) + 'px';
    var mh = m.offsetHeight;
    // se non ci sta sotto, si apre verso l'alto
    if (r.bottom + mh + 10 > window.innerHeight) m.style.top = Math.max(8, r.top - mh - 6) + 'px';
    refreshAvailability(vs);
  }

  function vPick(opt){
    if (opt.classList.contains('out')) return;
    var vs = opt.closest('.eta-vsel');
    vs.dataset.value = opt.dataset.value;
    var t = vs.querySelector('.eta-vtrig');
    var nm = t.querySelector('.nm');
    nm.textContent = opt.querySelector('b').textContent;
    nm.classList.remove('ph');
    var sw = t.querySelector('.sw');
    if (sw && opt.dataset.sw) sw.setAttribute('style', opt.dataset.sw);
    vs.querySelectorAll('.eta-vopt').forEach(function(o){ o.classList.remove('sel'); });
    opt.classList.add('sel');
    closeVMenus();
    if (vs.classList.contains('vcol')) scrollToColor(opt.dataset.value);
    bundlePrices();
  }

  /* Marca esaurite le opzioni che non hanno nessuna variante disponibile
     insieme all'altra opzione già scelta nella stessa riga. */
  function refreshAvailability(vsel){
    var row = vsel.closest('.eta-prow');
    if (!row) return;
    var chosen = [];
    row.querySelectorAll('.eta-vsel').forEach(function(s){ chosen[+s.dataset.opt] = s.dataset.value; });
    var idx = +vsel.dataset.opt;
    vsel.querySelectorAll('.eta-vopt').forEach(function(o){
      var probe = chosen.slice();
      probe[idx] = o.dataset.value;
      var anyAvailable = C.variants.some(function(v){
        for (var j=0;j<NOPT;j++){
          if (probe[j] && String(v.options[j]) !== String(probe[j])) return false;
        }
        return v.available;
      });
      o.classList.toggle('out', !anyAvailable);
    });
  }

  document.addEventListener('click', function(e){ if (!e.target.closest('.eta-vsel')) closeVMenus(); });
  window.addEventListener('scroll', function(){ closeVMenus(); }, { passive:true });

  /* ---------------- pixel ---------------- */

  function activeVar(){
    var b = document.querySelector('.eta-bun.on');
    if (b){
      var r = b.querySelector('.eta-prow');
      if (r){
        var o = [];
        r.querySelectorAll('.eta-vsel').forEach(function(s){ o[+s.dataset.opt] = s.dataset.value; });
        var v = variantFor(o);
        if (v) return v;
      }
    }
    return firstAvail();
  }

  /*
   * Eventi verso i pixel.
   *
   * Il carrello e il checkout sono custom, quindi Shopify non emette niente:
   * ogni evento parte da qui. eventID e lo stesso identificativo che la
   * Conversions API dovrà rimandare server-side, così Meta deduplica invece di
   * contare due volte.
   */
  function eventId(){
    return 'eta-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function contentsOf(map){
    var out = [];
    for (var id in map){
      var v = null;
      for (var i = 0; i < C.variants.length; i++) if (String(C.variants[i].id) === String(id)) v = C.variants[i];
      out.push({
        content_id: String(id),
        content_type: 'product',
        content_name: C.title,
        quantity: map[id],
        price: v ? v.price / 100 : 0
      });
    }
    return out;
  }

  function track(name, opts){
    opts = opts || {};
    var cur = C.currency || 'EUR';
    var contents = opts.contents;
    if (!contents){
      var v = activeVar();
      if (!v) return;
      var m = {};
      m[v.id] = BQ;
      contents = contentsOf(m);
    }
    var value = opts.value;
    if (value === undefined){
      value = 0;
      for (var i = 0; i < contents.length; i++) value += contents[i].price * contents[i].quantity;
      value = Math.round(value * 100) / 100;
    }
    var id = opts.eventId || eventId();
    var ids = contents.map(function(c){ return c.content_id; });

    try {
      if (window.fbq) {
        fbq('track', name, {
          content_ids: ids,
          content_type: 'product',
          contents: contents.map(function(c){ return { id: c.content_id, quantity: c.quantity, item_price: c.price }; }),
          content_name: C.title,
          value: value,
          currency: cur,
          num_items: contents.reduce(function(a, c){ return a + c.quantity; }, 0)
        }, { eventID: id });
      }
    } catch(e){}

    try {
      if (window.ttq) {
        // TikTok non ha ViewCart: si usa l'evento standard più vicino
        var ttName = name === 'ViewCart' ? 'ClickButton' : name;
        ttq.track(ttName, { contents: contents, value: value, currency: cur, event_id: id });
      }
    } catch(e){}

    try {
      if (window.gtag) {
        var GA = {
          ViewContent: 'view_item',
          AddToCart: 'add_to_cart',
          ViewCart: 'view_cart',
          InitiateCheckout: 'begin_checkout'
        };
        gtag('event', GA[name] || name, {
          currency: cur,
          value: value,
          items: contents.map(function(c){
            return { item_id: c.content_id, item_name: c.content_name, price: c.price, quantity: c.quantity };
          })
        });
      }
    } catch(e){}

    // gli eventi restano leggibili dal bridge di checkout e da script esterni
    try {
      document.dispatchEvent(new CustomEvent('eta:event', {
        detail: { name: name, eventId: id, value: value, currency: cur, contents: contents }
      }));
    } catch(e){}

    return id;
  }

  /* ---------------- carrello ---------------- */

  function openCart(){
    document.getElementById('eta-ov').classList.add('on');
    document.getElementById('eta-cart').classList.add('on');
    document.body.style.overflow = 'hidden';
    renderCart();
    prewarmCheckout();
    track('ViewCart');
  }

  function openMenu(){
    document.getElementById('eta-ov').classList.add('on');
    document.getElementById('eta-menu').classList.add('on');
    document.body.style.overflow = 'hidden';
  }

  function closeAll(){
    ['eta-ov','eta-cart','eta-menu'].forEach(function(id){
      var e = document.getElementById(id);
      if (e) e.classList.remove('on');
    });
    document.body.style.overflow = '';
  }

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape'){ closeAll(); kpolClose(); sizeGuide(false); }
  });

  async function qtyChange(key, q){
    try {
      await fetch('/cart/change.js', {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ id:key, quantity:q })
      });
    } catch(e){}
    renderCart();
  }

  function tierFor(qty){
    var tiers = C.bundles || [];
    var best = { qty:1, disc:0 };
    for (var i=0;i<tiers.length;i++){ if (qty >= tiers[i].qty && tiers[i].qty >= best.qty) best = tiers[i]; }
    return best;
  }

  async function renderCart(){
    var body = document.getElementById('eta-cbody');
    if (!body) return;
    var c;
    try { c = await (await fetch('/cart.js')).json(); } catch(e){ return; }

    var cnt = document.getElementById('eta-cnt');
    if (cnt){ cnt.textContent = c.item_count; cnt.style.display = c.item_count ? 'flex' : 'none'; }

    var foot = document.getElementById('eta-cfoot');
    var bar = document.getElementById('eta-shipbar');
    var total = document.getElementById('eta-ctot');

    if (!c.items.length){
      body.innerHTML = '<div class="eta-cempty">' + ICON.cart +
        '<b>' + (L.cartEmpty || 'Your cart is empty') + '</b>' +
        '<p>' + (L.cartEmptySub || '') + '</p>' +
        '<button class="eta-btn" data-eta="close">' + (L.keepShopping || 'Keep shopping') + '</button></div>';
      if (total) total.textContent = money(0);
      if (foot) foot.style.display = 'none';
      if (bar) bar.style.display = 'none';
      return;
    }
    if (foot) foot.style.display = '';
    if (bar) bar.style.display = 'flex';

    body.innerHTML = c.items.map(function(i){
      var vt = (i.variant_title && i.variant_title !== 'Default Title') ? i.variant_title : '';
      vt = vt.split(' / ').map(function(x){
        return (C.colorMap && C.colorMap[x.toLowerCase().trim()]) || x;
      }).join(' / ');
      var pt = (C.titleMap && C.titleMap[i.handle]) || i.product_title;
      return '<div class="eta-ci">' +
        '<img class="eta-cimg" src="' + (i.image || '') + '" alt="">' +
        '<div class="eta-cinfo">' +
          '<div class="ct">' + esc(pt) + '</div>' +
          '<div class="cvar">' + esc(vt) + '</div>' +
          '<div class="eta-cqp"><div class="eta-qty">' +
            '<button data-eta="qty" data-key="' + i.key + '" data-q="' + (i.quantity-1) + '">−</button>' +
            '<span>' + i.quantity + '</span>' +
            '<button data-eta="qty" data-key="' + i.key + '" data-q="' + (i.quantity+1) + '">+</button>' +
          '</div><span class="eta-cp">' + money(i.final_line_price) + '</span></div>' +
        '</div>' +
        '<button class="eta-crm" data-eta="qty" data-key="' + i.key + '" data-q="0" aria-label="Rimuovi">×</button>' +
      '</div>';
    }).join('');

    var tier = tierFor(c.item_count);
    var rate = tier.disc || 0;
    var lines = [];
    c.items.forEach(function(i){ for (var n=0;n<i.quantity;n++) lines.push(i.final_price); });
    var sub = c.items_subtotal_price;
    var disc = bundleDisc(lines, rate);

    var sum = document.getElementById('eta-csum');
    if (sum){
      var html = '<div class="sl"><span>' + (L.subtotal || 'Subtotal') + '</span><span>' + money(sub) + '</span></div>';
      if (disc > 0){
        html += '<div class="sl dc"><span>' + (L.discount || 'Discount') + ' ' + Math.round(rate*100) + '%</span><span>− ' + money(disc) + '</span></div>';
      }
      sum.innerHTML = html;
    }
    if (total) total.textContent = money(sub - disc);

    var gifts = document.getElementById('eta-cgifts');
    if (gifts && C.gifts){
      var list = C.gifts[String(tier.qty)] || C.gifts['1'] || [];
      gifts.innerHTML = '<div class="gh">' + (L.included || 'Included in your order') + '</div>' +
        list.map(function(g){ return '<div class="g">' + ICON.check + g + '</div>'; }).join('');
    }
  }

  /* ---------------- add to cart ---------------- */

  async function addToCart(el){
    var original = el ? el.innerHTML : '';
    var warn = document.getElementById('eta-warn');
    var bun = document.querySelector('.eta-bun.on') || document.querySelector('.eta-bun');
    var rows = bun ? bun.querySelectorAll('.eta-prow') : [];
    var counts = {}, missing = false;

    if (rows.length){
      rows.forEach(function(r){
        var o = [], miss = false;
        r.querySelectorAll('.eta-vsel').forEach(function(s){
          var val = s.dataset.value;
          o[+s.dataset.opt] = val;
          if (!val) miss = true;
        });
        if (miss){ missing = true; return; }
        var v = variantFor(o);
        if (!v){ missing = true; return; }
        counts[v.id] = (counts[v.id] || 0) + 1;
      });
    } else {
      var v0 = activeVar();
      if (v0) counts[v0.id] = BQ;
    }

    if (missing){ return showWarn(warn, L.pickOptions || 'Select the options for each item.'); }

    var items = Object.keys(counts).map(function(id){ return { id: parseInt(id,10), quantity: counts[id] }; });
    if (!items.length){ return showWarn(warn, L.pickOptions || 'Select the options.'); }

    if (el){ el.classList.add('loading'); el.innerHTML = '<span class="eta-spin"></span>' + (L.adding || 'Adding…'); }

    try {
      var res = await fetch('/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ items: items })
      });
      if (!res.ok){
        var err = {};
        try { err = await res.json(); } catch(e){}
        showWarn(warn, err.description || err.message || (L.cartError || 'Could not add to cart.'));
        restore(el, original);
        return;
      }
      track('AddToCart', { contents: contentsOf(counts) });
    } catch(e){
      showWarn(warn, L.networkError || 'Network error, please try again.');
      restore(el, original);
      return;
    }

    if (warn) warn.style.display = 'none';
    if (el){
      el.innerHTML = ICON.check + (L.added || 'Added');
      setTimeout(function(){ restore(el, original); }, 1400);
    }
    openCart();
  }

  function showWarn(el, msg){
    if (!el) return;
    el.textContent = msg;
    el.style.display = 'block';
  }
  function restore(el, html){
    if (!el) return;
    el.classList.remove('loading');
    el.innerHTML = html;
  }
  function esc(s){
    return String(s).replace(/[&<>"]/g, function(c){
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;' }[c];
    });
  }

  /* ---------------- checkout ---------------- */

  function prewarmCheckout(){
    if (!C.checkoutPrewarmUrl) return;
    try {
      fetch(C.checkoutPrewarmUrl, { method:'GET', mode:'no-cors', cache:'no-store', credentials:'omit' }).catch(function(){});
    } catch(e){}
  }

  function goCheckout(el){
    if (el){
      el.classList.add('loading');
      if (el.offsetParent !== null) el.innerHTML = '<span class="eta-spin"></span>' + (L.redirecting || 'Redirecting…');
    }
    track('InitiateCheckout');
    window.location.href = C.checkoutUrl || '/checkout';
  }

  /* ---------------- carosello recensioni ---------------- */

  function revScroll(dir){
    var w = document.getElementById('eta-revs');
    if (!w) return;
    var card = w.querySelector('.eta-rev');
    var step = card ? card.offsetWidth + 14 : w.clientWidth * 0.85;
    w.scrollBy({ left: dir*step, behavior:'smooth' });
  }

  /* ---------------- guida taglie ---------------- */

  function sizeGuide(open){
    var m = document.getElementById('eta-sizeguide');
    if (!m) return;
    m.hidden = !open;
    if (open) {
      document.body.style.overflow = 'hidden';
      var sc = m.querySelector('.eta-kpm-scroll');
      if (sc) sc.scrollTop = 0;
    } else if (!document.querySelector('.eta-cart.on')) {
      document.body.style.overflow = '';
    }
  }

  /* ---------------- popup policy ---------------- */

  function kpolOpen(key){
    var m = document.getElementById('eta-kpm');
    if (!m) return;
    m.querySelectorAll('[data-kp]').forEach(function(a){ a.hidden = a.dataset.kp !== key; });
    m.hidden = false;
    document.body.style.overflow = 'hidden';
    var sc = m.querySelector('.eta-kpm-scroll');
    if (sc) sc.scrollTop = 0;
  }
  function kpolClose(){
    var m = document.getElementById('eta-kpm');
    if (!m || m.hidden) return;
    m.hidden = true;
    if (!document.querySelector('.eta-cart.on')) document.body.style.overflow = '';
  }

  /* ---------------- icone inline ---------------- */

  var ICON = {
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" width="14" height="14"><polyline points="20 6 9 17 4 12"/></svg>',
    cart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="18" cy="21" r="1"/><path d="M3 4h2l2.4 12.3a1 1 0 0 0 1 .7h9.2a1 1 0 0 0 1-.8L21 8H6"/></svg>'
  };

  /* ---------------- delega eventi ---------------- */

  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-eta]');
    if (!t) return;
    var action = t.dataset.eta;

    if (action === 'sizeguide'){ e.preventDefault(); e.stopPropagation(); sizeGuide(true); }
    else if (action === 'sg-close'){ e.preventDefault(); sizeGuide(false); }
    else if (action === 'bun'){ pickBun(t); }
    else if (action === 'vtrig'){ vToggle(t); }
    else if (action === 'vopt'){ vPick(t); }
    else if (action === 'atc'){ e.preventDefault(); addToCart(t); }
    else if (action === 'open-cart'){ e.preventDefault(); openCart(); }
    else if (action === 'open-menu'){ e.preventDefault(); openMenu(); }
    else if (action === 'close'){ e.preventDefault(); closeAll(); }
    else if (action === 'qty'){ e.preventDefault(); qtyChange(t.dataset.key, +t.dataset.q); }
    else if (action === 'checkout'){ e.preventDefault(); goCheckout(t); }
    else if (action === 'rev'){ e.preventDefault(); revScroll(+t.dataset.dir); }
    else if (action === 'policy'){ e.preventDefault(); kpolOpen(t.dataset.key); }
    else if (action === 'policy-close'){ e.preventDefault(); kpolClose(); }
    else if (action === 'top'){
      e.preventDefault();
      var target = document.getElementById('eta-bsel') || document.body;
      target.scrollIntoView({ behavior:'smooth', block:'center' });
    }
  });

  /* ---------------- avvio ---------------- */

  /* Il carrello si disegna sempre: esiste anche dove non c'è un prodotto, e
     chi arriva sulla homepage con roba dentro deve vederla. */
  renderCart();
  setTimeout(prewarmCheckout, 700);

  /* Prezzi dei bundle e evento di visualizzazione parlano del prodotto: senza,
     non hanno niente da dire. */
  if (HASPROD){
    bundlePrices();
    track('ViewContent');
  }

  // esposte per compatibilità con snippet esterni (es. bridge di checkout)
  window.etaOpenCart = openCart;
  window.etaGoCheckout = goCheckout;
})();
